import { cn } from '../../lib/utils';

interface MessageBubbleProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Telegram-styled message bubble component.
 * 
 * Mimics the appearance of a Telegram channel post (not a personal
 * chat message). Uses Telegram's visual design including background
 * colors, border radius, and shadow.
 */
export function MessageBubble({ children, className }: MessageBubbleProps) {
  return (
    <div
      className={cn(
        'tg-message-bubble',
        'rounded-xl bg-white shadow-sm dark:bg-card dark:shadow-none',
        'max-w-full break-words p-3',
        className
      )}
    >
      {children}
    </div>
  );
}
